// Script pour corriger automatiquement les images de produits écrasées
// Version améliorée pour gérer le lazy-loading

console.log('[Fix Product Images] Script chargé');

// Attendre que le DOM et les scripts soient complètement chargés
window.addEventListener('load', function() {
  console.log('[Fix Product Images] Window load - début de la correction');
  
  // Délai pour s'assurer que le lazy-loading est initialisé
  setTimeout(function() {
    fixAllProductImages();
    observeNewImages();
  }, 500);
});

// Observer pour les nouvelles images chargées dynamiquement
function observeNewImages() {
  // Observer les changements de classe sur les images (lazyload -> lazyloaded)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const img = mutation.target;
        if (img.tagName === 'IMG' && img.classList.contains('lazyloaded')) {
          console.log('[Fix Product Images] Image lazy-loaded détectée:', img.alt);
          checkAndFixImage(img);
        }
      }
    });
  });
  
  // Observer toutes les images produits
  document.querySelectorAll('.product-featured-image-link img').forEach(function(img) {
    observer.observe(img, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
  
  // Observer aussi pour les nouveaux produits ajoutés au DOM
  const domObserver = new MutationObserver(function() {
    fixAllProductImages();
  });
  
  domObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function fixAllProductImages() {
  const productImages = document.querySelectorAll('.product-featured-image-link img');
  console.log('[Fix Product Images] Nombre d\'images trouvées:', productImages.length);
  
  productImages.forEach(function(img) {
    // Vérifier si l'image est déjà corrigée
    if (img.getAttribute('data-fixed') === 'true') {
      return;
    }
    
    // Pour les images lazy-load, attendre qu'elles soient chargées
    if (img.classList.contains('lazyload') && !img.classList.contains('lazyloaded')) {
      console.log('[Fix Product Images] Image en attente de lazy-load:', img.alt);
      // L'observer s'en occupera
      return;
    }
    
    // Pour les images déjà chargées ou lazyloaded
    if (img.complete || img.classList.contains('lazyloaded')) {
      checkAndFixImage(img);
    } else {
      // Au cas où, ajouter un listener
      img.addEventListener('load', function() {
        checkAndFixImage(img);
      });
    }
  });
}

function checkAndFixImage(img) {
  // Petit délai pour s'assurer que les dimensions sont disponibles
  setTimeout(function() {
    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;
    
    if (naturalWidth && naturalHeight) {
      const imageRatio = naturalWidth / naturalHeight;
      const container = img.closest('.product-featured-image-link');
      
      if (container) {
        const containerWidth = container.offsetWidth;
        const containerHeight = container.offsetHeight;
        const containerRatio = containerWidth / containerHeight;
        const ratioDifference = Math.abs(imageRatio - containerRatio);
        
        console.log('[Fix Product Images] Analyse:', {
          image: img.alt || img.src,
          imageRatio: imageRatio.toFixed(2),
          containerRatio: containerRatio.toFixed(2),
          difference: ratioDifference.toFixed(2)
        });
        
        // Critères élargis pour détecter les images problématiques
        if (imageRatio < 0.7 || imageRatio > 1.5 || ratioDifference > 0.3) {
          console.log('[Fix Product Images] Correction appliquée pour:', img.alt);
          img.style.objectFit = 'contain';
          img.style.backgroundColor = 'var(--color-product-card-bg, #fff)';
          img.setAttribute('data-fixed', 'true');
        }
      }
    }
  }, 100);
}